import withInjection from '@piconetworks/with-injection'
import Logout from 'common/components/Logout'

import Loader from 'common/modules/loader'
import xFrame from 'common/xFrame'

const mapStateToProps = (state) => ({
    publisherId: Loader.selectors.publisherId(state),
    disableLoading: true,
})

const mapDispatchToProps = (dispatch) => ({
    logout: () => {
        xFrame.menu.logout({ dispatch })
    },
})

const InjectedLogout = withInjection(Logout, {
    mapStateToProps,
    mapDispatchToProps,
})

export default InjectedLogout
